module.exports = __webpack_public_path__ + "media/images/icon-search-f1b044c15b697077b85abf72175802b2.png";